import React from 'react';
import { CHART_COLORS } from './chartTheme';

/**
 * Circular score gauge (0–100 by default).
 */
export default function ScoreGauge({
  value = 0,
  max = 100,
  size = 140,
  label,
  sublabel,
  color,
}) {
  const pct = max > 0 ? Math.max(0, Math.min(1, Number(value) / max)) : 0;
  const stroke = color
    || (pct <= 0
      ? CHART_COLORS.slate
      : pct >= 0.75
        ? CHART_COLORS.success
        : pct >= 0.45
          ? CHART_COLORS.warning
          : CHART_COLORS.danger);
  const r = 52;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - pct);
  const display = Number.isFinite(Number(value))
    ? (max === 100 ? `${Math.round(Number(value))}%` : String(Math.round(Number(value))))
    : '—';

  return (
    <div className="flex w-full flex-col items-center justify-center py-2" style={{ minHeight: size }}>
      <svg width={size} height={size} viewBox="0 0 140 140" aria-hidden>
        <circle
          cx="70"
          cy="70"
          r={r}
          fill="none"
          stroke={CHART_COLORS.track}
          strokeWidth="12"
        />
        <circle
          cx="70"
          cy="70"
          r={r}
          fill="none"
          stroke={stroke}
          strokeWidth="12"
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          transform="rotate(-90 70 70)"
        />
        <text
          x="70"
          y="74"
          textAnchor="middle"
          className="fill-slate-900"
          style={{ fontSize: 22, fontWeight: 700 }}
        >
          {display}
        </text>
      </svg>
      {label ? <p className="mt-1 text-sm font-semibold text-slate-800">{label}</p> : null}
      {sublabel ? <p className="text-xs text-slate-500">{sublabel}</p> : null}
    </div>
  );
}
